import React from 'react';
import { IUser } from '../../types/damTypes';
import AIImageStudioPage from './AIImageStudioPage';

interface AIImageStudioModuleProps {
  onClose: () => void;
  currentUser: IUser | null;
  initialRecipeAssetId?: string | null;
  initialEditAssetId?: string | null;
}

const AIImageStudioModule: React.FC<AIImageStudioModuleProps> = ({
  onClose,
  currentUser,
  initialRecipeAssetId,
  initialEditAssetId,
}) => {
  return (
    <AIImageStudioPage
      onClose={onClose}
      currentUser={currentUser}
      initialRecipeAssetId={initialRecipeAssetId}
      initialEditAssetId={initialEditAssetId}
    />
  );
};

export default AIImageStudioModule;
